import { useState } from 'react';
export const useAutoDateFormatter = () => {
    const [formattedInput, setFormattedInput] = useState('');
    const handleInputDate = (value, formatType) => {
        // Length of full date is 10 characters
        if (value.length > 10)
            return;
        // Make sure backspace is working well (prevent auto-adding dashes)
        if (value.length < formattedInput.length) {
            setFormattedInput(value);
            return;
        }
        // Only allow numbers
        const lastTypedChar = value[value.length - 1];
        if (isNaN(parseInt(lastTypedChar, 10)))
            return;
        // Add dash after 2 characters and 5 characters if "DD-MM-YYYY" or add dash after 4 characters and 7
        const formatted = formatType === "DD-MM-YYYY" ? (value.length === 2 ? `${value}-` : value.length === 5 ? `${value}-` : value) : (value.length === 4 ? `${value}-` : value.length === 7 ? `${value}-` : value);
        setFormattedInput(formatted);
    };
    return { handleInputDate, formattedInput };
};
//# sourceMappingURL=useAutoDateFormatter.js.map